"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchCheckoutConsignmentHomeDeliveryAddressesPath = exports.searchCheckoutConsignmentHomeDeliveryAddresses = void 0;
const utils_1 = require("@invivodf/utils");
const utils_2 = require("../../../utils");
const searchCheckoutConsignmentHomeDeliveryAddresses = (client) => async ({ checkoutId, consignmentId, cityCode }) => {
    try {
        const response = await client.post((0, exports.searchCheckoutConsignmentHomeDeliveryAddressesPath)(checkoutId, consignmentId), { cityCode });
        return utils_1.Result.success(response.data);
    }
    catch (error) {
        if ((0, utils_2.isFunctionalApiError)(error)) {
            return utils_1.Result.failure({
                code: error.body.code,
                message: error.body.message
            });
        }
        throw error;
    }
};
exports.searchCheckoutConsignmentHomeDeliveryAddresses = searchCheckoutConsignmentHomeDeliveryAddresses;
const searchCheckoutConsignmentHomeDeliveryAddressesPath = (checkoutId, consignmentId) => `/v2/bff/appro/checkouts/${checkoutId}/consignments/${consignmentId}/home-delivery-addresses/search`;
exports.searchCheckoutConsignmentHomeDeliveryAddressesPath = searchCheckoutConsignmentHomeDeliveryAddressesPath;
